<style>
@import '@/assets/css/custom.css';
</style>

<template>
	<div>
		<Breadcrumbs main="Accounts" title="User Payment Logs" />

		<div class="container-fluid">
			<div class="row">
				<div class="col-sm-12">
					<div class="card">
						<div class="card-body">
							<div class="row mb-3">
								<div class="col-12">
									<a href="#" @click.prevent="$router.go(-1)" class="btn btn-primary float-end">
										<i class="bx bx-chevrons-left"></i> Back
									</a>
								</div>
							</div>

							<div class="row mb-2" v-if="userHeader">
								<div class="col-md-12">
									<div class="alert alert-light border d-flex flex-wrap gap-3 mb-2">
										<div><strong>User:</strong> {{ user_data.user_name ? user_data.user_name : user_data.customer_name ? user_data.customer_name : user_data.dealer_name ? user_data.dealer_name : "—" }}</div>
										<div><strong>Mobile:</strong> {{ user_data.user_mobile || "—" }}</div>
										<div><strong>Type:</strong> {{ paymentUserTypeLabel(userHeader.payment_user_type) }}</div>
									</div>
								</div>
							</div>

							<div class="col-md-12 project-list filter-sort">
								<div class="row align-items-end">
									<div class="col-md-6 d-flex mt-2">
										<label class="d-flex listing-length ms-1 align-items-center">
											<span>Show</span>
											<select class="form-select mx-2" style="width: auto" v-model="listing_length" @change="fetchTransactions()">
												<option value="5">5</option>
												<option value="10">10</option>
												<option value="20">20</option>
											</select>
											<span>entries</span>
										</label>
									</div>
								</div>
							</div>

							<div class="table-responsive product-table mt-3">
								<table class="display table">
									<thead>
										<tr align="center">
											<th>Sl.No</th>
											<th>Payment Date</th>
											<th>Payment Type</th>
											<th>Status</th>
											<th>For</th>
											<th>Work Amount</th>
											<th>Advance Amount</th>
											<th>Due Amount</th>
											<th>Cash</th>
											<th>Online</th>
											<!-- <th>Opening</th> -->
											<th>Closing</th>
											<th>Deduct From Credit</th>
											<th>Done By</th>
										</tr>
									</thead>
									<tbody v-if="rows.length">
										<tr align="center" v-for="(row, index) in rows" :key="row.id">
											<td>{{ from != null ? from + index : index + 1 }}</td>
											<td>{{ row.payment_date ? $filters.formatDate(row.payment_date) : "—" }}</td>
											<td>
												<span class="badge rounded-pill bg-info text-dark">{{ paymentTypeLabel(row.payment_type) }}</span>
											</td>
											<td>
												<span class="badge rounded-pill" :class="paymentStatusClass(row.payment_status)">
													{{ paymentStatusLabel(row.payment_status) }}
												</span>
											</td>
											<td>{{ paymentForLabel(row.payment_for) }}</td>
											<td>₹{{ formatMoney(row.work_amount) }}</td>
											<td :class="creditAmountClass(row.credit_amount)">
												₹{{ formatMoney(row.credit_amount) }}
											</td>
											<td :class="dueAmountClass(row.pending_amount)">
												₹{{ formatMoney(row.pending_amount) }}
											</td>
											<td>₹{{ formatMoney(row.cash_amount) }}</td>
											<td>₹{{ formatMoney(row.online_amount) }}</td>
											<!-- <td>₹{{ formatMoney(row.opening_balance) }}</td> -->
											<td class="fw-bold">₹{{ formatMoney(row.closing_balance) }}</td>
											<td>
												<span class="badge rounded-pill bg-success" v-if="row.is_deduct_from_credit == 1">Yes</span>
												<span class="badge rounded-pill bg-secondary" v-else>No</span>
											</td>
											<td>{{ row.added_by_name || "—" }}</td>
										</tr>
									</tbody>
									<tbody v-else>
										<tr>
											<td colspan="13" align="center">No transactions found</td>
										</tr>
									</tbody>
								</table>
							</div>

							<caption v-if="rows.length" class="float-start mt-2 d-block">
								Showing {{ from }} to {{ to }} of {{ total }} entries
							</caption>
							<nav v-if="rows.length && pagination.length" aria-label="Page navigation" class="mt-2 float-end">
								<ul class="pagination mb-0">
									<li
										class="page-item"
										v-bind:class="[{ disabled: !page.url }, { active: page.active }]"
										v-for="(page, index) in pagination"
										:key="'p-' + index + '-' + page.label"
									>
										<a class="page-link" href="#" @click.prevent="onPageClick(page, index)" tabindex="-1">
											<span v-if="index === 0">Prev</span>
											<span v-else-if="index === pagination.length - 1">Next</span>
											<span v-else>{{ page.label }}</span>
										</a>
									</li>
								</ul>
							</nav>

						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: "UserPaymentLogs",
	data() {
		return {
			token: "",
			listing_length: 10,
			user_id: "",
			user_data: null,
			rows: [],
			userHeader: null,
			pagination: [],
			from: 0,
			to: 0,
			total: 0,
			active_page_url: "",
		};
	},
	created() {
		this.user_id = this.$route?.params?.id || this.$route?.query?.user_id || "";
		this.fetchTransactions();
	},
	watch: {
		"$route.params.id"(val) {
			this.user_id = val || "";
			this.fetchTransactions();
		},
	},
	methods: {
		getToken() {
			if (localStorage.getItem("airotrack_staff")) {
				const airotrack_staff = JSON.parse(localStorage.getItem("airotrack_staff"));
				if (airotrack_staff.token) {
					this.token = airotrack_staff.token;
				} else {
					this.$swal("", "Failed to fetch token, please login again", "error");
					this.$router.push({ name: "login" });
				}
			} else {
				this.$swal("", "Session expired, please login again", "error");
				this.$router.push({ name: "login" });
			}
		},

		listUrl() {
			return `/staffs/userTransactions?limit=${this.listing_length}&user_id=${encodeURIComponent(this.user_id || "")}`;
		},

		fetchTransactions(pageUrl) {
			if (!this.user_id) {
				this.rows = [];
				this.pagination = [];
				return;
			}

			this.getToken();
			const url = pageUrl || this.listUrl();
			this.active_page_url = url;
			this.$axios
				.get(url, { headers: { Authorization: "Bearer " + this.token } })
				.then((res) => {
					const ok = res.data.status === "true" || res.data.status === true;
					if (!ok) {
						this.rows = [];
						this.pagination = [];
						return;
					}
					const paginator = res.data.data?.userTransactions;
					this.user_data = res.data.data?.user || null;
					console.log(this.user_data);
					this.rows = paginator?.data || [];
					this.pagination = paginator?.links || [];
					this.from = paginator?.from ?? 0;
					this.to = paginator?.to ?? 0;
					this.total = paginator?.total ?? 0;
					this.userHeader = this.rows.length ? this.rows[0] : null;
				})
				.catch((err) => {
					console.error(err);
					this.$swal("Error", err.response?.data?.message || "Failed to load transactions", "error");
					this.rows = [];
					this.pagination = [];
				});
		},

		onPageClick(page) {
			if (!page.url) return;
			const base = page.url;
			const sep = base.includes("?") ? "&" : "?";
			this.fetchTransactions(`${base}${sep}limit=${this.listing_length}&user_id=${encodeURIComponent(this.user_id || "")}`);
		},

		formatMoney(value) {
			const n = parseFloat(value);
			if (isNaN(n)) return "0.00";
			return n.toFixed(2);
		},

		creditAmountClass(value) {
			const n = parseFloat(value);
			if (isNaN(n)) return "";
			if (n < 0) return "text-danger";
			if (n > 0) return "text-success";
			return "";
		},

		dueAmountClass(value) {
			const n = parseFloat(value);
			if (isNaN(n)) return "";
			if (n > 0) return "text-danger";
			if (n < 0) return "text-success";
			return "";
		},

		paymentTypeLabel(v) {
			const map = { 1: "Incoming", 2: "Outgoing", 3: "Payment Pending", 4: "Advance" };
			return map[Number(v)] || "—";
		},
		paymentStatusLabel(v) {
			const map = { 1: "Received", 2: "Pending", 3: "Partially", 4: "From Advance" };
			return map[Number(v)] || "—";
		},
		paymentStatusClass(v) {
			const n = Number(v);
			if (n === 1) return "bg-success";
			if (n === 2) return "bg-warning text-dark";
			if (n === 3) return "bg-info text-dark";
			if (n === 4) return "bg-secondary";
			return "bg-light text-dark";
		},
		paymentForLabel(v) {
			const map = { 1: "Renewal", 2: "Work Service", 3: "Payment In", 4: "Payment Out", 5: "Contra", 6: "Other", 7: "Sales", 8: "Extension" };
			return map[Number(v)] || "—";
		},
		paymentUserTypeLabel(v) {
			const map = { 1: "Dealer", 2: "Customer" };
			return map[Number(v)] || "—";
		},
	},
};
</script>

